"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressInformationStep = void 0;
const react_1 = __importStar(require("react"));
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const boutik_gatsby_plugin_components_1 = require("@sbi-international/boutik.gatsby.plugin.components");
const boutik_gatsby_plugin_multilocale_1 = require("@sbi-international/boutik.gatsby.plugin.multilocale");
const createMfpProCustomerAccountContext_1 = require("../../../../../contexts/createMfpProCustomerAccountContext");
const customerAccountContext_1 = require("../../../../../contexts/customerAccountContext");
const countriesRegionsHelper_1 = require("../../../../../helpers/countriesRegionsHelper");
const constants_1 = require("../../../../../constants");
const arrowDirectionType_1 = require("../../../../../models/arrowDirectionType");
const NavigationButton_1 = require("../NavigationButton");
const AddressInformationStep = ({ updateCurrentStep }) => {
    const customerAccountContext = (0, react_1.useContext)(customerAccountContext_1.CustomerAccountContext);
    const { countries } = customerAccountContext.actions.addresses.countryHook();
    const { currentLocale } = (0, boutik_gatsby_plugin_multilocale_1.usePageLocalization)();
    const createMfpProCustomerAccountContext = (0, react_1.useContext)(createMfpProCustomerAccountContext_1.CreateMfpProCustomerAccountContext);
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    const useFormMethods = (0, react_hook_form_1.useForm)({
        defaultValues: createMfpProCustomerAccountContext.state.address,
    });
    const watchCountryId = useFormMethods.watch("countryId");
    const countriesSelect = (0, react_1.useMemo)(() => {
        const allowedCountryCodes = [countriesRegionsHelper_1.UNITED_STATES_COUNTRY_ID, countriesRegionsHelper_1.CANADA_COUNTRY_ID];
        const filteredCountries = countries.filter((country) => allowedCountryCodes.includes(country.id));
        const mappedCountries = filteredCountries.map((country) => ({
            value: country.id,
            label: country.full_name_locale,
        }));
        return mappedCountries;
    }, [countries]);
    const regionsSelect = (0, react_1.useMemo)(() => {
        var _a, _b, _c;
        return ((_c = (_b = (_a = (0, countriesRegionsHelper_1.getCountryById)(countries, watchCountryId)) === null || _a === void 0 ? void 0 : _a.available_regions) === null || _b === void 0 ? void 0 : _b.map((region) => ({ value: region.id, label: region.name }))) !== null && _c !== void 0 ? _c : []);
    }, [watchCountryId]);
    const isSelectedCountryUS = () => {
        return watchCountryId === countriesRegionsHelper_1.UNITED_STATES_COUNTRY_ID;
    };
    const onSubmit = (data) => {
        createMfpProCustomerAccountContext.updateState({ address: data });
        updateCurrentStep(1);
    };
    const onPrevious = (data) => {
        createMfpProCustomerAccountContext.updateState({ address: data });
        updateCurrentStep(-1);
    };
    return (react_1.default.createElement(react_hook_form_1.FormProvider, Object.assign({}, useFormMethods),
        react_1.default.createElement("form", { className: "boutik-customer-account-create-mfp-pro-account-address-container", onSubmit: useFormMethods.handleSubmit(onSubmit) },
            react_1.default.createElement("h1", { className: "boutik-customer-account-create-mfp-pro-account-address-title" }, t("createMfpProCustomerAccount.address.title")),
            react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "address", label: t("createMfpProCustomerAccount.address.address"), required: true }),
            react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "phoneNumber", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.newPhoneNumberValidation(currentLocale), label: t("createMfpProCustomerAccount.address.phoneNumber"), required: true }),
            react_1.default.createElement("label", { className: "boutik-customer-account-create-mfp-pro-account-address-select-input-label" },
                t("createMfpProCustomerAccount.address.country"),
                react_1.default.createElement("span", { className: "boutik-customer-account-create-mfp-pro-account-address-select-input-required" }, " *")),
            react_1.default.createElement(boutik_gatsby_plugin_components_1.ReactSelect.ReactSelectUseFormWrapper, { control: useFormMethods.control, controlName: "countryId", rules: {
                    required: t("global.errors.required"),
                }, reactSelectWrapperProps: {
                    placeholder: t("createMfpProCustomerAccount.address.placeholder.countrySelect"),
                    noOptionsMessage: t("global.placeholder.reactSelectNoOptions"),
                    options: countriesSelect,
                    value: "",
                    errorMessage: {
                        message: "",
                        className: "boutik-customer-account-react-select-wrapper-error-message",
                        position: "bottom",
                    },
                    styles: boutik_gatsby_plugin_components_1.ReactSelect.REACT_SELECT_WRAPPER_DEFAULT_STYLES,
                } }),
            react_1.default.createElement("label", { className: "boutik-customer-account-create-mfp-pro-account-address-select-input-label" },
                t(`createMfpProCustomerAccount.address.${isSelectedCountryUS() ? "state" : "province"}`),
                react_1.default.createElement("span", { className: "boutik-customer-account-create-mfp-pro-account-address-select-input-required" }, " *")),
            react_1.default.createElement(boutik_gatsby_plugin_components_1.ReactSelect.ReactSelectUseFormWrapper, { control: useFormMethods.control, controlName: "regionId", rules: {
                    required: t("global.errors.required"),
                }, reactSelectWrapperProps: {
                    placeholder: t(`createMfpProCustomerAccount.address.placeholder.${isSelectedCountryUS() ? "regionSelectState" : "regionSelectProvince"}`),
                    noOptionsMessage: t("global.placeholder.reactSelectNoOptions"),
                    options: regionsSelect,
                    value: "",
                    errorMessage: {
                        message: "",
                        className: "boutik-customer-account-react-select-wrapper-error-message",
                        position: "bottom",
                    },
                    styles: boutik_gatsby_plugin_components_1.ReactSelect.REACT_SELECT_WRAPPER_DEFAULT_STYLES,
                } }),
            react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "city", label: t("createMfpProCustomerAccount.address.city"), required: true }),
            react_1.default.createElement(boutik_gatsby_plugin_components_1.FormInput.Text, { context: useFormMethods, classNamePrefix: "boutik-customer-account", property: "postalCode", validations: boutik_gatsby_plugin_components_1.FormInput.FormValidation.newPostalOrZipCodeValidation(currentLocale, watchCountryId), label: t("createMfpProCustomerAccount.address.postalCode"), required: true }),
            react_1.default.createElement(NavigationButton_1.NavigationButton, { arrowDirection: arrowDirectionType_1.ArrowDirectionType.Left, onClick: () => onPrevious(useFormMethods.getValues()), label: t("createMfpProCustomerAccount.button.previous") }),
            react_1.default.createElement(NavigationButton_1.NavigationButton, { arrowDirection: arrowDirectionType_1.ArrowDirectionType.Right, isSubmitButton: true, label: t("createMfpProCustomerAccount.button.next") }))));
};
exports.AddressInformationStep = AddressInformationStep;
//# sourceMappingURL=AddressInformationStep.js.map